<template>
  <div class="question-forward-box box">
    <h2 class="box-title">
      <slot name="title">
        {{ $t("questionsPage.forward.title") }}
      </slot>
    </h2>
    <h3 class="box-subtitle">
      <slot name="subtitle">
        {{ $t("questionsPage.forward.subtitle") }}
      </slot>
    </h3>
    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="input-wrapper">
        <QuestionInputSearch
          :value.sync="question"
          rules="max:500"
          @keydown.native.enter="handleSubmit(forwardQuestion)"
        />
      </div>
      <button class="button is-primary" @click="handleSubmit(forwardQuestion)">
        <slot name="action">
          {{ $t("questionsPage.forward.action") }}
        </slot>
      </button>
    </ValidationObserver>
  </div>
</template>

<script>
import QuestionInputSearch from "~/components/QuestionInputSearch";

export default {
  components: { QuestionInputSearch },
  props: {
    professionTask: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      question: "",
    };
  },
  methods: {
    forwardQuestion() {
      let query = {
        q: this.question,
      };

      if (this.professionTask) {
        query = {
          ...query,
          ti: this.professionTask.id,
          tn: this.professionTask.name,
        };
      }

      this.$router.push({ path: "/szakivalaszol/uj-kerdes", query });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:math";
@use "styles/_all-members" as global;

$spacing: 10px;

.question-forward-box {
  border-radius: 1rem;
  padding: ($spacing * 3.5) ($spacing * 2.5);
  text-align: center;
  background: white;

  @include global.mobile {
    padding: ($spacing * 2) ($spacing * 1.5);
  }
}
.box-title {
  line-height: 1.33;
  font-size: 32px;

  @include global.mobile {
    margin-bottom: ($spacing * 1.5);
  }
}
.input-wrapper {
  margin: ($spacing * 2.5) 0 math.div($spacing, 2);
}
</style>
